import React, { useState, useEffect, useContext } from 'react';
import {Route, Routes} from "react-router-dom";

import Bel_Home from './bel/home.js';
import Bel_Cal from './bel/cal.js';
import Bel_Rt from './bel/rt.js';
import Bel_Room from './bel/room.js';
import Bel_Kf from './bel/kf.js';
import Bel_Rs from './bel/rs.js';
import Bel_Pk from './bel/pk.js';
import Bel_Rr from './bel/rr.js';
import Bel_Aba from './bel/aba.js';
import Bel_Bft from './bel/bft.js';
import {withRouter} from "../lib/react/withRouter";
import sso from "../sso";

function pg_home() {

    var html =
    <div className="web-content">
      Hem
    </div>
    ;
    return html;
}

class Pms_Bel extends React.Component {
    //var sdo = useContext(SDO);
  constructor(props, context) {
    super(props);

    this.webStore = props.store;
    this.state = { pgid: 11, deps: [] };
    //context.posrend = this;
  }
  fknGo(row) {
    //alert(row.href);
    sso.seo.sfkn = row;
    this.props.store.fkn = row;
    this.props.navigate(row.url);
  }
    br_css(row) {
        var css = {};
        if(sso.seo.sfkn && (row.url == sso.seo.sfkn.url)) css.color = "#080";
        //var brc = false;
        //if(row.url == sbo.state.url) brc = true;
        return css;
    }

  render() {
      var path = window.location.pathname;
      if(path.substr(-1) == "/") path = path.substring(0, path.length - 1);
      var op = path.split("/").pop();
      var po = {};
      po.rt = { "fid": "f02", "url": "/pms/bel/rt", "name": "Rumstyper", "active": false };
      po.room = { "fid": "f02", "url": "/pms/bel/room", "name": "Rum", "active": false };
      po.kf = { "fid": "f02", "url": "/pms/bel/kf", "name": "Konferens", "active": false };
      po.rs = { "fid": "f02", "url": "/pms/bel/rs", "name": "Resurs", "active": false };
      po.pk = { "fid": "f02", "url": "/pms/bel/pk", "name": "Paket", "active": false };
      po.rr = { "fid": "f02", "url": "/pms/bel/rr", "name": "Roomrack", "active": false };
      po.aba = { "fid": "f02", "url": "/pms/bel/aba", "name": "Ank-Bo-Avr", "active": false };
      po.bft = { "fid": "f02", "url": "/pms/bel/bft", "name": "Bokat", "active ": false };
      if(po[op]) {
          po[op].active = true;
      }
      var pa = Object.values(po);

    return (
    <div className="web-app">
         { this.props.store.cfg.bread ?
        <div className="web-bread">
            <div className="breadcrumb">
            { pa.map((row, key) =>
                <div className="breadcrumb-item" key={key} style={this.br_css(row)} onClick={() => this.fknGo(row)}>{row.name}</div>
            )}
            <div className="flex"></div>
            <div className="cdigreen">{ this.props.store.fkn ? this.props.store.fkn.name : null }</div>
            </div>
        </div>
        : null }
        <Routes>
          <Route path="/xx" component={pg_home} />
            <Route path="cal" element={ <Bel_Cal store={this.webStore} />} />
            <Route path="rt" element={ <Bel_Rt store={this.webStore} />} />
            <Route path="room" element={ <Bel_Room store={this.webStore} />} />
            <Route path="kf" element={ <Bel_Kf store={this.webStore} />} />
            <Route path="rs" element={ <Bel_Rs store={this.webStore} />} />
            <Route path="pk" element={ <Bel_Pk store={this.webStore} />} />
            <Route path="rr" element={ <Bel_Rr store={this.webStore} />} />
            <Route path="aba" element={ <Bel_Aba store={this.webStore} />} />
            <Route path="bft" element={ <Bel_Bft store={this.webStore} />} />
            <Route path="*" element={ <Bel_Home store={this.webStore} />} />
        </Routes>
    </div>
  );
}
}
//Sys.contextType = ADOContext;

export default withRouter(Pms_Bel);
